<template>
  <div>
    <div style="margin: 10px 0">
      <el-input
        style="width: 250px"
        placeholder="用户名,手机号,真实姓名筛选"
        v-model="username"
        size="medium"
        clearable
      ></el-input>
      <tree-select
        :treeValue="treeValue1"
        v-if="orgBack"
        @reset="orgName = ''"
        @treeAll="orgall"
        style="
          width: 294px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select>
      <el-select
        v-model="usertype"
        value-key=""
        placeholder="用户类别"
        clearable
        size="medium"
        filterable
      >
        <el-option
          v-for="item in adduserList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <!-- <el-input
        style="width: 150px"
        placeholder="医院名称筛选"
        v-model="orgName"
        clearable
      ></el-input> -->
      <el-button size="medium" @click="getpage(1)">筛选</el-button>
    </div>
    <div>
      <el-button size="medium" type="primary" plain @click="addUser"
        >新增用户</el-button
      >
      <el-button
        size="medium"
        type="warning"
        plain
        @click="uploadVisible = true"
        >批量新增</el-button
      >

      <el-button size="medium" type="danger" plain @click="getStateList"
        >同步异常列表</el-button
      >
      <el-button
        v-if="name === 'admin'"
        size="medium"
        type="danger"
        plain
        @click="batchDeleteVisible = true"
        >批量删除</el-button
      >
      <el-button
        :disabled="synchronizationList.length == 0"
        size="medium"
        type="danger"
        plain
        @click="synchronization"
        >批量同步</el-button
      >
      <el-button
        size="medium"
        type="success"
        plain
        @click="hospitalSynchronization = true"
        >根据医院批量同步</el-button
      >

      <el-button size="medium" plain @click="handleEditTime">
        按用户类别修改使用截止时间
      </el-button>
      <el-button size="medium" type="danger" @click="handleDel">
        一键删除过期用户
      </el-button>
      <el-button size="medium" type="warning" plain @click="handleExport">
        导出
      </el-button>
    </div>
    <div>
      <el-table :data="list" @select="choose" @select-all="chooseAll">
        <!-- <el-table-column align="center" label="ID" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建日期" width="230">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
          </template>
        </el-table-column> -->
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" label="用户名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>姓名: {{ scope.row.username }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.username }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="APP应用模块" width="180">
          <template slot-scope="scope">
            <el-checkbox-group>
              <el-checkbox-button
                v-for="(elem,i) of scope.row.appIdList"
                :label="elem"
                :key="i"
              >{{elem}}</el-checkbox-button>
            </el-checkbox-group>
          </template>
        </el-table-column>-->
        <el-table-column align="center" label="真实姓名">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户类别">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.usertype | filterUesrType
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="机构码">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.orgCode }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="邮箱">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.email }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="使用截止时间" width="140">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.endDate }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="name == 'admin'" align="center" label="用户密码">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.sourcePassword
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="是否开启IP免登陆" width="140">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.useIp"
              :active-value="1"
              :inactive-value="0"
              @change="changeIpLogin(scope.$index, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="用户状态" width="140">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              :active-value="1"
              :inactive-value="0"
              @change="changeIpLogin(scope.$index, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="550" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="warning"
              @click="handleState(scope.$index, scope.row)"
              >同步情况</el-button
            >
            <el-button
              size="mini"
              type="warning"
              @click="handleAnalysis(scope.$index, scope.row)"
              >权限设置</el-button
            >
            <el-button
              size="mini"
              type="warning"
              @click="handleRe(scope.$index, scope.row)"
              >重置密码</el-button
            >

            <!-- <el-button type="primary" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
            <p
              v-if="scope.row.wxOpenid || scope.row.qyOpenid"
              style="
                display: flex;
                justify-content: flex-start;
                margin-top: 10px;
                padding-left: 55px;
              "
            >
              <el-popconfirm
                title="你确定要解除微信绑定吗？"
                @onConfirm="wxDelete(scope.$index, scope.row)"
              >
                <el-button
                  v-show="scope.row.wxOpenid"
                  style="margin: 0 10px"
                  size="mini"
                  type="danger"
                  slot="reference"
                  >微信解绑</el-button
                >
              </el-popconfirm>
              <el-popconfirm
                title="你确定要解除企业微信绑定吗？"
                @onConfirm="qywxDelete(scope.$index, scope.row)"
              >
                <el-button
                  v-show="scope.row.qyOpenid"
                  style="margin: 0 10px"
                  size="mini"
                  type="danger"
                  slot="reference"
                  >企业微信解绑</el-button
                >
              </el-popconfirm>
            </p>

            <!-- <el-button
              size="mini"
              type="danger"
              v-if="scope.row.wxOpenid"
              @click="wxDelete(scope.$index, scope.row)"
            >微信解绑</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <!-- 新增，修改 -->
    <el-dialog :title="diaName" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="用户名" required>
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item v-if="diaName != '修改用户'" label="密码" required>
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="form.realName"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email"></el-input>
        </el-form-item>

        <el-form-item label="学科" required>
          <el-input v-model="form.subject"></el-input>
        </el-form-item>

        <!-- <el-form-item label="科室">
          <el-input v-model="form.department"></el-input>
        </el-form-item>-->
        <el-form-item label="机构" required>
          <tree-select
            :treeValue="treeValue"
            @treeAll="treeall"
            style="width: 200px"
            v-if="tree"
            :option="treeOption"
          ></tree-select>
        </el-form-item>
        <el-form-item label="科室">
          <el-select v-model="form.department" placeholder="请选择科室">
            <el-option
              v-for="item in departmentList"
              :key="item + Math.random()"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Ip免登陆">
          <div style="width: 200px">
            <el-switch
              v-model="form.useIp"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item label="Ip免登陆范围">
          <el-input
            :disabled="!form.useIp"
            style="min-width: 200px"
            type="textarea"
            :rows="3"
            placeholder="请输入Ip范围"
            v-model="form.ipScope"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Ip限制">
          <div style="width: 200px">
            <el-switch
              v-model="form.limitIp"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="Ip限制范围">
          <el-input
            :disabled="!form.limitIp"
            style="min-width: 200px"
            type="textarea"
            :rows="3"
            placeholder="请输入Ip范围"
            v-model="form.ipLimitScope"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="用户状态">
          <div style="width: 200px">
            <el-switch
              v-model="form.enable"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item label="用户类别" required>
          <div style="width: 200px">
            <el-select
              v-model="form.usertype"
              placeholder="请选择用户类别"
              clearable
              filterable
            >
              <el-option
                v-for="item in adduserList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="使用截止时间" required label-width="106">
          <div style="width: 200px">
            <el-date-picker
              v-model="form.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="APP应用模块">
          <el-checkbox-group v-model="form.appIdList">
            <el-checkbox-button v-for="(elem,i) of appList" :label="elem.id" :key="i">{{elem.name}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
    <!-- APP用户同步情况 -->
    <el-dialog title="APP用户同步情况" :visible.sync="stateVisible" width="30%">
      <el-table :data="stateList" style="width: 90%">
        <el-table-column align="center" label="APP用户名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>APP用户名: {{ scope.row.appName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.appName }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="是否同步">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>同步状态: {{ scope.row.syncStatus }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="warning" size="medium">{{
                  scope.row.syncStatus ? "是" : "否"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- APP用户同步列表 -->
    <el-dialog
      title="APP用户同步列表"
      :visible.sync="stateListVisible"
      width="40%"
    >
      <div style="height: 31rem">
        <div>
          <el-button @click="unusual('SYNC')" size="mini" type="success"
            >同步</el-button
          >
          <el-button @click="unusual('IGNORE')" size="mini" type="danger"
            >忽略</el-button
          >
        </div>
        <el-scrollbar style="height: 100%">
          <el-table
            :data="stateLists"
            @select="chooseUnusual"
            @select-all="chooseAllUnusual"
            style="width: 90%"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column align="center" label="用户名" width="180">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>用户名: {{ scope.row.username }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag size="medium">{{ scope.row.username }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column align="center" label="APP应用" width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.appName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              align="center"
              label="是否同步"
              width="180"
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>同步状态: {{ scope.row.syncStatus }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag type="danger" size="medium">{{
                      scope.row.syncStatus ? "是" : "否"
                    }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
    </el-dialog>
    <!-- 导入情况 -->
    <el-dialog
      :close-on-click-modal="false"
      title="重复导入列表："
      :visible.sync="leadinVisible"
      width="50%"
    >
      <div>
        <el-tag>总共导入：{{ leadinList.totalNum }}</el-tag>
        <el-tag type="success">成功导入：{{ leadinList.successNum }}</el-tag>
        <el-tag type="warning">重复导入：{{ leadinList.repeatNum }}</el-tag>
      </div>
      <div style="height: 30rem">
        <el-scrollbar style="height: 100%">
          <el-table :data="leadinList.repeatUserList" style="width: 90%">
            <el-table-column align="center" label="手机号" width="180">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>手机号: {{ scope.row.username }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag size="medium">{{ scope.row.username }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column align="center" label="用户名" width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.username }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="科室" width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.department
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="机构码" width="180">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>机构码: {{ scope.row.orgCode }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag type="warning" size="medium">{{
                      scope.row.orgCode
                    }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          icon="el-icon-delete"
          :loading="deletingRepeatUsers"
          :disabled="!repeatUsernames.length"
          @click="deleteRepeatUsers"
          >一键删除</el-button
        >
        <el-button @click="leadinVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 批量新增 -->
    <el-dialog title="批量新增" :visible.sync="uploadVisible" width="560px">
      <uploa @finish="getleadin" style="marginleft: 80px"></uploa>
    </el-dialog>
    <el-dialog
      title="批量同步"
      :visible.sync="hospitalSynchronization"
      width="560px"
    >
      <div style="height: 350px">
        <tree-select
          v-if="orgBack"
          :treeValue="hospitalOrgValue"
          @treeAll="hospitalOrgall"
          style="
            width: 400px;
            display: inline-block;
            verticalalign: bottom;
            fontsize: 14px;
          "
          placeholder="请输入医院名称"
          :alwaysOpen="true"
          :option="orgOption"
        ></tree-select>
        <el-button
          :disabled="!hospitalCode"
          @click="gethospitalSynchronization"
          size="medium"
          type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 是否开启统计分析 -->
    <el-dialog title="权限设置" :visible.sync="analysisVisible" width="30%">
      <div style="margin-bottom: 20px">
        <label s>是否开启统计分析：</label>
        <el-radio size="small" v-model="enableTjfx" :label="1" border
          >是</el-radio
        >
        <el-radio size="small" v-model="enableTjfx" :label="0" border
          >否</el-radio
        >
      </div>
      <div>
        <label s>是否开启密码修改：</label>
        <el-radio size="small" v-model="enablePassword" :label="1" border
          >是</el-radio
        >
        <el-radio size="small" v-model="enablePassword" :label="0" border
          >否</el-radio
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="analysisVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="analysisBool"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 批量删除 -->
    <el-dialog title="批量删除" :visible.sync="batchDeleteVisible" width="35%">
      <div style="margin-bottom: 20px">
        <label s>请输入用户名，多个用户名之间以','分离</label>
      </div>

      <el-input type="textarea" rows="3" v-model="batchDeleteUsers"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="batchDeleteUser"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量修改 -->
    <el-dialog
      title="批量修改使用截止时间"
      :visible.sync="editDateVisible"
      width="600px"
    >
      <div>
        <el-form :model="editDateForm" ref="form" label-width="180px">
          <el-form-item label="当前机构：">
            <el-input v-model="editDateForm.orgName" disabled></el-input>
          </el-form-item>
          <el-form-item label="职工使用截止时间：" prop="staffEndDate">
            <el-date-picker
              v-model="editDateForm.staffEndDate"
              type="date"
              placeholder="选择日期时间"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="住培学员使用截止时间：" prop="residentEndDate">
            <el-date-picker
              v-model="editDateForm.residentEndDate"
              type="date"
              placeholder="选择日期时间"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="研究生使用截止时间：" prop="postgraduateEndDate">
            <el-date-picker
              v-model="editDateForm.postgraduateEndDate"
              type="date"
              placeholder="选择日期时间"
              style="width: 100%"
              :picker-options="endDatePickerOptions"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="实习生使用截止时间：" prop="internEndDate">
            <el-date-picker
              v-model="editDateForm.internEndDate"
              type="date"
              placeholder="选择日期时间"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="进修生使用截止时间：" prop="advancedEndDate">
            <el-date-picker
              v-model="editDateForm.advancedEndDate"
              type="date"
              placeholder="选择日期时间"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="其他使用截止时间：" prop="otherEndDate">
            <el-date-picker
              v-model="editDateForm.otherEndDate"
              type="date"
              placeholder="选择日期时间"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancle">取消</el-button>
            <el-button type="primary" @click="onSubmit">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
import uploa from "./upload";
import { exportUser } from "@/api/api";
export default {
  components: {
    treeSelect,
    page,
    uploa,
  },
  filters: {
    filterUesrType(val) {
      var statusTxet = [
        "其他",
        "职工",
        "住培学员",
        "研究生",
        "实习生",
        "进修生",
      ];
      return statusTxet[val];
    },
  },
  created() {
    this.name = sessionStorage.getItem("admin");
    this.orgBack = false;
    sessionStorage.getItem("orgId") == 1
      ? (this.orgValue = null)
      : (this.orgValue = sessionStorage.getItem("orgId"));
    this.$api.structureList().then((res) => {
      // console.log(res)
      if (res.data.code == 200) {
        this.orgBack = true;
        this.orgOption = res.data.data;
        const grp = sessionStorage.getItem("grp");
        if (["3", "4"].includes(grp)) {
          const orgId = sessionStorage.getItem("orgId");
          this.orgName = this.orgOption.find((item) => item.id == orgId)?.code;
          this.treeValue1 = orgId;
        }
        this.load();
      }
    });
  },
  mounted() {
    this.getAppIds();
  },
  data() {
    return {
      usertype: "",
      name: "",
      batchDeleteVisible: false,
      batchDeleteUsers: "",
      synchronizationList: [], //同步ids
      unusualList: [], //异常列表
      username: "",
      orgName: "",
      orgValue: null,
      orgOption: [],
      orgBack: false,
      enablePassword: "",
      treeValue1: undefined,
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      appList: [],
      analysisVisible: false,
      analysisId: 0,
      enableTjfx: 0,
      dialogVisible: false,
      stateVisible: false,
      stateListVisible: false,
      uploadVisible: false,
      leadinVisible: false,
      deletingRepeatUsers: false,
      editDateVisible: false,
      hospitalSynchronization: false,
      tree: false,
      treeOption: [],
      stateList: [],
      stateLists: [],
      leadinList: [],
      departmentList: [],
      editDateForm: {
        endDate: "",
        orgCode: "",
        orgName: "",
        advancedEndDate: "", //进修生使用
        internEndDate: "", //实习生使用
        otherEndDate: "", //其他使用截止时间
        postgraduateEndDate: "", //研究生
        residentEndDate: "", //住培学员使用截止时间
        staffEndDate: "", //职工
      },
      form: {
        username: "", //用户名
        password: "", //密码
        realName: "", //真实姓名
        id: "", //
        phone: "",
        email: "",
        department: "",
        useIp: 0,
        limitIp: 0,
        ipScope: "",
        ipLimitScope: "",
        subject: "", //学科
        orgCode: "",
        appIdList: [],
        enable: 0,
        usertype: "",
        endDate: "",
      },
      treeValue: null,
      hospitalOrgValue: null,
      hospitalCode: "",
      diaName: "新增用户",
      adduserList: [
        {
          value: 0,
          label: "其他",
        },
        {
          value: 1,
          label: "职工",
        },
        {
          value: 2,
          label: "住培学员",
        },
        {
          value: 3,
          label: "研究生",
        },
        {
          value: 4,
          label: "实习生",
        },
        {
          value: 5,
          label: "进修生",
        },
      ],
    };
  },
  computed: {
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const { endDate } = this.editDateForm;
          // 如果 endDate 为空或无效，不禁用任何日期
          if (!endDate) {
            return false;
          }
          // 确保 endDate 是合法日期字符串（如 "2025-04-30"）
          const maxTime = new Date(endDate).getTime();
          // 如果解析失败，也不限制
          if (isNaN(maxTime)) {
            return false;
          }
          return time.getTime() > maxTime;
        },
      };
    },
    repeatUsernames() {
      const repeatUserList = this.leadinList.repeatUserList || [];
      return [
        ...new Set(repeatUserList.map((user) => user.username).filter(Boolean)),
      ];
    },
  },
  methods: {
    cancle() {
      this.editDateVisible = false;
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          console.log(this.editDateForm);
          const params = { ...this.editDateForm };
          delete params.endDate;
          delete params.orgName;
          this.$api.updateEndDate(params).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.editDateVisible = false;
              setTimeout(() => {
                this.load();
              }, 1000);
              this.$nextTick(() => {
                if (this.$refs.form) {
                  this.$refs.form.clearValidate();
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    handleDel() {
      if (!this.orgName) {
        return this.$message.warning("请先选择机构");
      } else {
        this.$confirm("是否确认删除过期用户", "", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then((action) => {
            this.$api
              .deleteExpired({ orgCode: this.orgName })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message({ message: "操作成功", type: "success" });
                  setTimeout(() => {
                    this.load();
                  }, 1000);
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {});
          })
          .catch(() => {});
      }
    },
    handleEditTime() {
      if (!this.orgName) {
        return this.$message.warning("请先选择机构");
      }

      // 根据 orgName 查找机构信息
      const org = this.orgOption.find((item) => item.code === this.orgName);
      // 重置表单数据
      this.editDateForm = {
        orgCode: this.orgName,
        orgName: org.name,
        endDate: org.endDate || "", // 机构的全局截止时间（可能为空）

        // 以下字段清空
        staffEndDate: "", // 职工
        residentEndDate: "", // 住培学员
        postgraduateEndDate: "", // 研究生
        internEndDate: "", // 实习生
        advancedEndDate: "", // 进修生
        otherEndDate: "", // 其他
      };

      // 显示对话框
      this.editDateVisible = true;

      // 如果你希望同时重置表单校验状态（清除红色错误提示）
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate(); // 只清除校验，不清空数据（但我们已经手动重置了）
        }
      });
    },

    //根据医院批量同步
    gethospitalSynchronization() {
      let obj = {
        orgCode: this.hospitalCode,
        type: "ORG",
      };
      this.$api
        .synchronization(obj)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: "同步成功",
              type: "success",
            });
            this.hospitalSynchronization = false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //批量同步
    synchronization() {
      let obj = {
        ids: this.synchronizationList,
        type: "IDS",
      };
      this.$api
        .synchronization(obj)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: "同步成功",
              type: "success",
            });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    choose(selection, row) {
      // console.log(selection)
      this.synchronizationList = selection.map((elem) => elem.id);
      console.log(this.synchronizationList);
    },
    chooseAll(selection) {
      this.synchronizationList = selection.map((elem) => elem.id);
      console.log(this.synchronizationList);
    },
    //异常选中
    chooseUnusual(selection, row) {
      // console.log(selection)
      this.unusualList = selection.map((elem) => elem.id);
      console.log(this.unusualList);
    },
    chooseAllUnusual(selection) {
      this.unusualList = selection.map((elem) => elem.id);
      console.log(this.unusualList);
    },
    //异常同步&忽略
    unusual(type) {
      let obj = {
        ids: this.unusualList,
        type: type,
      };
      this.$api
        .synErrorUser(obj)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getStateList();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取医院信息
    orgall(x) {
      this.orgName = x.code;
      // this.form.department = x.name;
    },
    //获取医院信息
    hospitalOrgall(x) {
      this.hospitalCode = x.code;
      console.log(this.hospitalCode);
      // this.form.department = x.name;
    },
    //获取医院信息
    treeall(x) {
      console.log(x);
      // this.form.department = x.name;
      this.structureSelect(x.id);
      this.form.orgCode = x.code;
      this.form.appIdList = x.appIdList ? x.appIdList : [];
      // 若机构有endDate，则回填到使用截止时间；若没有则清空
      this.form.endDate = x.endDate || "";
    },
    structureSelect(x) {
      console.log(x);
      this.$api.structureSelect({ parentId: x }).then((res) => {
        console.log(res);
        this.departmentList = res.data.data.map((elem) => elem.name);
      });
    },
    //打开新增用户页面，请求树形组件内容
    addUser() {
      this.structureSelect(sessionStorage.getItem("orgId"));
      this.diaName = "新增用户";
      this.treeValue = null;
      this.form = {
        username: "", //用户名
        password: "", //密码
        realName: "", //真实姓名
        id: "",
        useIp: 0,
        limitIp: 0,
        ipScope: "",
        ipLimitScope: "",
        phone: "",
        email: "",
        department: "",
        subject: "未分类", //学科
        orgCode: "",
        appIdList: [],
        enable: 1,
        endDate: "",
        usertype: "",
      };
      this.dialogVisible = true;
      this.tree = false;
      this.$api.structureList().then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          this.treeValue = Number(sessionStorage.getItem("orgId"));
          this.tree = true;
          this.treeOption = res.data.data;
          console.log(res.data.data);
          res.data.data.map((elem) => {
            if (elem.id == sessionStorage.getItem("orgId")) {
              this.form.appIdList = elem.appIdList ? elem.appIdList : [];
              this.form.orgCode = elem.code;
            }
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    add() {
      console.log(this.form);
      this.$api
        .addUpdataAppUser(this.form)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    analysisBool() {
      let obj = {
        userId: this.analysisId,
        enableTjfx: this.enableTjfx,
        enablePassword: this.enablePassword,
      };
      this.$api.AppUserAnalysisBool(obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.analysisVisible = false;
        }
        // console.log(res)
      });
    },
    handleAnalysis(index, row) {
      this.$api.AppUserAnalysisList({ userid: row.id }).then((res) => {
        this.enableTjfx = res.data.data.enableTjfx;
        this.enablePassword = res.data.data.enablePassword;
        this.analysisId = res.data.data.userId;
        // console.log(res.data)
        this.analysisVisible = true;
      });
    },
    handleEdit(index, row) {
      this.diaName = "修改用户";
      // this.treeValue=row.orgId//默认值
      console.log(row);
      this.form.username = row.username;
      this.form.password = "";
      this.form.id = row.id;
      this.form.subject = row.subject;
      this.form.orgCode = row.orgCode;
      this.form.department = row.department;
      this.form.phone = row.phone;
      this.form.realName = row.realName;
      this.form.useIp = row.useIp;
      this.form.limitIp = row.limitIp;
      this.form.ipScope = row.ipScope;
      this.form.ipLimitScope = row.ipLimitScope;
      this.form.email = row.email;
      this.form.enable = row.enable;
      this.form.usertype = row.usertype;
      this.form.endDate = row.endDate;
      //  this.form.appIdList = row.appIdList?row.appIdList:[];
      // this.form.appIdList = row.appIdList;
      this.dialogVisible = true;
      this.tree = false;
      this.$api.structureList().then((res) => {
        if (res.data.code == 200) {
          console.log(res.data.data);
          this.treeOption = res.data.data;
          res.data.data.map((elem) => {
            if (elem.code == this.form.orgCode) {
              this.treeValue = elem.id;
              this.form.appIdList = elem.appIdList ? elem.appIdList : [];
              this.form.orgCode = elem.code;
              this.structureSelect(elem.id);
            }
          });
          console.log(this.form);
          // this.treeall()
          this.tree = true;
        }
      });
      // console.log(index, row);
    },
    changeIpLogin(index, row) {
      let obj = row;
      this.$api
        .addUpdataAppUser(obj)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      console.log(index, row);
    },
    //重置密码
    handleRe(index, row) {
      this.$prompt("请输入新密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          // console.log(row.id, value);
          this.$api
            .AppupdatePwd({
              id: row.id,
              password: value,
            })
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });

      console.log(index, row);
    },
    getStateList() {
      this.$api
        .AppUserInfoError()
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.stateLists = res.data.data;
            this.stateListVisible = true;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    //app同步情况
    handleState(index, row) {
      this.$api
        .AppUserInfo({
          id: row.id,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.stateList = res.data.data;
            this.stateVisible = true;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });

      // console.log(index, row);
    },
    //删除用户
    handleDelete(index, row) {
      console.log(row.id);
      this.$api.appUserDelete(row.id).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
      console.log(index, row);
    },
    //微信解绑
    wxDelete(index, row) {
      console.log(row.id);
      this.$api.wxUntie(row.id).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "解绑成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
      console.log(index, row);
    },
    //企业微信解绑
    qywxDelete(index, row) {
      console.log(row);
      this.$api.qywxUntie(row.id).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "解绑成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.username,
        orgCode: this.orgName,
      };
      if (this.usertype || this.usertype === 0) {
        obj.usertype = this.usertype;
      }
      console.log(obj);
      this.$api.AppUserList(obj).then((res) => {
        console.log(res.data.data.records);

        if (res.data.code == 200) {
          this.$set(this, "list", res.data.data.records);
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    //获取app列表
    getAppIds() {
      this.$api.AppRunList({}).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.appList = res.data.data.records.map((elem) => {
            return {
              id: elem.id,
              name: elem.name,
            };
          });
          // console.log(this.appList);
        }
      });
    },
    //获取导入结果
    getleadin(x) {
      console.log(x);
      this.leadinList = x;
      this.uploadVisible = false;
      this.leadinVisible = true;
    },
    deleteRepeatUsers() {
      if (!this.repeatUsernames.length) {
        this.$message.error("没有可删除的重复用户");
        return;
      }

      this.$confirm("此操作将删除重复上传的用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deletingRepeatUsers = true;
          // 接口单次最多删除 20 个，超过则分批调用（如 21 个分 2 次：第一次 20 个，第二次 1 个）
          const batchSize = 20;
          const usernames = this.repeatUsernames;
          const batches = [];
          for (let i = 0; i < usernames.length; i += batchSize) {
            batches.push(usernames.slice(i, i + batchSize));
          }
          let successCount = 0;
          let failCount = 0;
          return batches
            .reduce((promise, batch) => {
              return promise.then(() =>
                this.$api
                  .batchDelete("usernames=" + batch.join(",") + ",")
                  .then((res) => {
                    if (res.data.code == 200) {
                      successCount += batch.length;
                    } else {
                      failCount += batch.length;
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    failCount += batch.length;
                  }),
              );
            }, Promise.resolve())
            .then(() => {
              if (failCount === 0) {
                this.$message.success("重复用户删除成功");
                this.leadinVisible = false;
              } else if (successCount > 0) {
                this.$message.warning(
                  "部分删除成功：成功 " +
                    successCount +
                    " 个，失败 " +
                    failCount +
                    " 个",
                );
              } else {
                this.$message.error("重复用户删除失败");
              }
              if (successCount > 0) {
                this.load();
                this.getAppIds();
              }
            });
        })
        .catch((err) => {
          if (err !== "cancel") {
            console.log(err);
          }
        })
        .finally(() => {
          this.deletingRepeatUsers = false;
        });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
      this.load();
    },
    // 导出
    handleExport() {
      this.$api.exportUser(
        this.username,
        this.orgName,
        "Bearer " + sessionStorage.getItem("access_token"),
      );
    },
    batchDeleteUser() {
      const usernames = this.batchDeleteUsers
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
      if (usernames.length === 0) {
        this.$message.error("请输入用户名");
        return;
      }

      this.$confirm("此操作将删除输入的用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 接口单次最多删除 20 个，超过则分批调用
          const batchSize = 20;
          const batches = [];
          for (let i = 0; i < usernames.length; i += batchSize) {
            batches.push(usernames.slice(i, i + batchSize));
          }
          let successCount = 0;
          let failCount = 0;
          return batches
            .reduce((promise, batch) => {
              return promise.then(() =>
                this.$api
                  .batchDelete("usernames=" + batch.join(","))
                  .then((res) => {
                    if (res.data.code == 200) {
                      successCount += batch.length;
                    } else {
                      failCount += batch.length;
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    failCount += batch.length;
                  }),
              );
            }, Promise.resolve())
            .then(() => {
              if (failCount === 0) {
                this.$message.success("批量删除成功");
                this.batchDeleteUsers = "";
                this.batchDeleteVisible = false;
              } else if (successCount > 0) {
                this.$message.warning(
                  "部分删除成功：成功 " +
                    successCount +
                    " 个，失败 " +
                    failCount +
                    " 个",
                );
              } else {
                this.$message.error("批量删除失败");
              }
              if (successCount > 0) {
                this.load();
                this.getAppIds();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped></style>
